<div *ngIf="listingId && openInNewTab" class="external-link" title="Open listing admin page in new tab" (click)="onClick($event)">
  <span class="link">
    <i class="fa fa-external-link"></i>
  </span>
</div>
<div *ngIf="listingId && !openInNewTab" class="external-link" title="Open listing admin page" (click)="onClick($event)">
  <span class="link">
    <i class="fa fa-external-link"></i>
  </span>
</div>
